declare namespace $ {

	export class $mol_icon_sort_ascending extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=ascending.view.tree.d.ts.map